import request from "@/CommonDP/utils/request";
export default {
    //添加部门
    getorgaddDept(params) {
        return request.post(`/org-manage/addSupplier`, params).then(res => res);
    },
    //查询列表
    getOrgTree(params) {
        return request.post(`/org-manage/getSupplierList`, params).then(res => res);
    },
    // 本部门下的人员列表
    orgUserList(params) {
        return request.post(`/lc/dept/member/list`, params);
    },

    //供方导入人员
    supplierPersonImport(params) {
        return request
        .post(`/supplier-org/manage/invite/import/generateCode`, params)
        .then(res => res);
    },

    delSupplier(deptId) {
        return request
        .post(`/org-manage/org-delete?deptId=${deptId}`)
        .then(res => res);
    },

    editSupplier(params) {
        return request
        .post(`/org-manage/org-edit`, params)
        .then(res => res);
    },
     // 账号启用禁用
    setEnabled({enterpriseUserId, enabled}) {
        return request.get(`/lc/enterprise/personnel/enabled?enabled=${enabled}&enterpriseUserId=${enterpriseUserId}`)
    },
    initPassword({userId}) {
        return request.post(`/user/initPassword?userId=${userId}`)
    },
}
